// Example: REACT_APP_API_URL=http://127.0.0.1:8000/api
export const API_BASE = (process.env.REACT_APP_API_URL || "/api").replace(/\/$/, "");

function withApiBase(path) {
  if (typeof path === "string" && (path.startsWith("http://") || path.startsWith("https://"))) {
    return path;
  }

  const p = path.startsWith("/") ? path : `/${path}`;

  // If API_BASE is absolute (http://127.0.0.1:8000/api), join cleanly.
  if (API_BASE.startsWith("http://") || API_BASE.startsWith("https://")) {
    // If p is already "/api/..." we should not double-prefix.
    if (p.startsWith("/api/")) return `${API_BASE.replace(/\/api$/, "")}${p}`;
    return `${API_BASE}${p}`;
  }

  // Otherwise API_BASE is relative (/api)
  if (p.startsWith(API_BASE + "/") || p === API_BASE) return p;
  return `${API_BASE}${p}`;
}

export function buildApiUrl(path) {
  return withApiBase(path);
}

// Get token directly from localStorage (much faster than supabase.auth.getSession())
function getTokenFromStorage() {
  try {
    const keys = Object.keys(localStorage).filter(k => k.includes('auth-token') && k.startsWith('sb-'));
    if (keys.length === 0) return null;
    
    const authData = localStorage.getItem(keys[0]);
    if (!authData) return null;
    
    const parsed = JSON.parse(authData);
    return parsed?.access_token || null;
  } catch (e) {
    console.warn('Failed to get token from localStorage:', e);
    return null;
  }
}

export async function apiFetch(path, options = {}) {
  const { skipAuth = false, ...fetchOptions } = options;
  const headers = new Headers(fetchOptions.headers || {});

  if (!skipAuth && !headers.has("Authorization")) {
    const token = getTokenFromStorage();
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
  }

  const url = withApiBase(path);
  return fetch(url, { ...fetchOptions, headers });
}
